import React from 'react';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import pick from 'lodash/pick';

export const WH_RADIO_PLAY_REQUESTED = 'mediaplayers.whradio.play';
export const WH_RADIO_PAUSE_REQUESTED = 'mediaplayers.whradio.stop';
export const WH_RADIO_MUTE_REQUESTED = 'mediaplayers.whradio.mute';
export const WH_RADIO_UNMUTE_REQUESTED = 'mediaplayers.whradio.unmute';

export const RADIO_STATE_UPDATED = 'wh.sports.event.radio.state.updated';
export const RADIO_MUTE_TOGGLE = 'wh.sports.event.radio.mute.toggle';
export const RADIO_PLAY_CLICKED = 'wh.sports.event.radio.play.clicked';
export const RADIO_PAUSE_CLICKED = 'wh.sports.event.radio.pause.clicked';
export const RADIO_MARQUEE_ANIMATION_START = 'wh.sports.event.radio.marquee-animation.start';

export const ANIMATION_DELAY = 3000;
export const WH_RADIO_TYPE_RADIO = 'radio';
export const WH_RADIO_TYPE_LINK = 'link';

const withRadio = (WrappedComponent, componentProps = {}) => {
  class RadioWrapper extends React.Component {
    state = {
      animationOn: false,
      marqueeText: '',
      muted: false,
      playing: false,
      playingLabel: '',
    };

    componentDidMount() {
      this.subscribeStateUpdate = subscribe({
        topic: RADIO_STATE_UPDATED,
        callback: this.stateUpdate,
      });
    }

    componentWillUnmount() {
      if (this.subscribeStateUpdate) {
        unsubscribe(this.subscribeStateUpdate);
      }
      clearTimeout(this.textAnimationTimeout);
    }

    onPlayRequested = (data) => {
      publish({ topic: RADIO_PLAY_CLICKED, data });
      this.animateMarqueeText();
    };

    onPauseRequested = () => {
      publish({ topic: RADIO_PAUSE_CLICKED });
    };

    onMuteToggle = () => {
      publish({ topic: RADIO_MUTE_TOGGLE });
    };

    onClickHandler = (radioProps) => (e) => {
      const isCalledFromEqualizer = e.target.classList.contains('equalizer');

      if (!isCalledFromEqualizer && radioProps.type === WH_RADIO_TYPE_RADIO) {
        radioProps.label === this.state.playingLabel ? this.onPauseRequested() : this.onPlayRequested(radioProps);
      } else if (radioProps.type === WH_RADIO_TYPE_LINK) {
        window.open(radioProps.link, radioProps.target);
      }
    };

    animateMarqueeText = () => {
      if (!componentProps.isNested && !this.state.animationOn && this.state.marqueeText) {
        clearTimeout(this.textAnimationTimeout);

        this.textAnimationTimeout = setTimeout(() => {
          this.setState({ animationOn: true });
          publish({ topic: RADIO_MARQUEE_ANIMATION_START });
        }, ANIMATION_DELAY);
      }
    };

    stateUpdate = ({ data = {} } = {}) => {
      const newState = pick(data, Object.keys(this.state));
      this.setState(newState, () => {
        if (!componentProps.isNested) {
          this.animateMarqueeText();
        }
      });
    };

    render() {
      const { children, ...restProps } = componentProps;
      const props = {
        ...restProps,
        ...this.state,
        key: componentProps.forwardedKey,
        onPlayRequested: this.onPlayRequested,
        onPauseRequested: this.onPauseRequested,
        onMuteToggle: this.onMuteToggle,
        onClickHandler: this.onClickHandler,
        stateUpdate: this.stateUpdate,
        animateMarqueeText: this.animateMarqueeText,
      };
      if (children) {
        return <WrappedComponent {...props}>{children}</WrappedComponent>;
      }
      return <WrappedComponent {...props} />;
    }
  }

  return RadioWrapper;
};

export default withRadio;
